import "../css/app.css";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()


// Animate On Scroll Options
// https://github.com/michalsnik/aos
import AOS from 'aos'
import 'aos/dist/aos.css' // make sure the CSS gets bundled

// init after DOM is ready
window.addEventListener('DOMContentLoaded', () => {
    AOS.init({
        // If you truly want to disable on phones, keep 'phone' — but see fallback below.
        // Better: respect reduced motion instead of device type:
        disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        duration: 400,
        // Use a positive offset so elements can animate even on short/no-scroll pages
        offset: 80,
        once: true,
        startEvent: 'DOMContentLoaded',
    })
})

// refresh after heavy assets (images/video/iframes) finish
window.addEventListener('load', () => {
    AOS.refreshHard()
})

// Optional: expose for debugging and let other scripts refresh after dynamic changes
window.AOS = AOS


// Show made by Spaceray Creative banner.
if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
    var n = ["\n %c Made with ♥ by Spaceray Creative %c %c %c https://www.spaceraycreative.com/ \n\n", "color: #a0d39d; background: #0b4061; padding:5px 0;", "background: #4c4c4d; padding:5px 0;", "background: #4c4c4d; padding:5px 0;", "color: #fff; background: #1c1c1c; padding:5px 0;"];
    window.console.log.apply(console, n)
} else
    window.console && window.console.log("Made with love ♥ by Spaceray Creative - https://www.spaceraycreative.com/")

// Pause/play service videos on hover.
document.addEventListener('DOMContentLoaded', function () {
    const figures = document.querySelectorAll('.video');

    figures.forEach(function (figure) {
        const video = figure.querySelector('video');

        if (video) {
            figure.addEventListener('mouseenter', () => video.play());
            figure.addEventListener('mouseleave', () => video.pause());
        }
    });
});

// Medium Zoom plugin -- Zoom image effect on images)
import mediumZoom from 'medium-zoom'

// Swiper
import Swiper, { Pagination, Autoplay, Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Pagination, Autoplay, Navigation])

// Run layout-mutating stuff *after* DOM is ready so AOS can refresh correctly
window.addEventListener('DOMContentLoaded', () => {
    // Medium Zoom
    mediumZoom('[data-zoomable]', {
        margin: 24,
        background: '#fff',
        scrollOffset: 0,
    })

    // Testimonial Swiper
    const testimonialSwiper = new Swiper('.testimonial-swiper', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass:
                'swiper-pagination-bullet bg-gray-300 inline-block w-3 h-3 rounded-full mx-1 transition',
            bulletActiveClass: 'bg-primary',
        },
        on: {
            // after Swiper lays out slides, remeasure for AOS
            afterInit: () => AOS.refresh(),
        },
    })

    // Services Swiper
    // (Calculate loop based on slides inside THIS container, not the whole document)
    const servicesContainer = document.querySelector('.services-spotlights')
    const slideCount = servicesContainer
        ? servicesContainer.querySelectorAll('.swiper-slide').length
        : 0

    const servicesSwiper = new Swiper('.services-spotlights', {
        loop: slideCount >= 4,
        slidesPerView: 1.1,
        centeredSlides: true,
        breakpoints: {
            768: {
                slidesPerView: 2.8,
                centeredSlides: false,
                spaceBetween: 24,
                loop: slideCount >= 3,
            },
            1024: {
                slidesPerView: 3.2,
                centeredSlides: false,
                spaceBetween: 24,
                loop: slideCount >= 4,
            },
            1280: {
                slidesPerView: 4.8,
                centeredSlides: false,
                spaceBetween: 24,
                loop: slideCount >= 5,
            },
            1536: {
                slidesPerView: 4.2,
                centeredSlides: false,
                spaceBetween: 24,
                loop: slideCount >= 6,
            },
        },
        navigation: { nextEl: '.swiper-next', prevEl: '.swiper-prev' },
        on: {
            afterInit: () => AOS.refresh(),
        },
    })

    const staticSwiper = new Swiper('.static-swiper', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        navigation: { nextEl: '.swiper-next', prevEl: '.swiper-prev' },
        on: {
            afterInit: () => AOS.refresh(),
        },
    })
})

// Optional: once Alpine finishes the first reactive flush, refresh AOS
// (Alpine fires 'alpine:init' before start(); here we refresh after start)
queueMicrotask(() => {
    if (window.Alpine) {
        // If you create components that reveal content later, refresh again there too
        AOS.refresh()
    }
})


// Social Media Sharing Window
var socialShares = document.querySelectorAll('.social-share a');
if (socialShares) {
    [].forEach.call(socialShares, function (anchor) {
        anchor.addEventListener('click', function (e) {
            var url = this.href,
                width = 500,
                height = 300,
                left = screen.width / 2 - width / 2,
                top = screen.height / 2 - height / 2;

            if (/^(f|ht)tps?:\/\//i.test(url) || /^mailto/i.test(url)) {
                e.preventDefault();
                window.open(
                    url,
                    '',
                    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
                    width +
                    ',height=' +
                    height +
                    ',top=' +
                    top +
                    ',left=' +
                    left,
                );
            }
        });
    });
}

